import {
  onGoingStatus,
} from '../../utils/constants'

export const sectionFiltersMap = {
  market: {
    status: ['WAIT_TRANSPORTER_ACCEPT', 'NEGOTIATION'],
    selectedStatus: 'all',
    initLaunchDate: null,
    endLaunchDate: null,
    tab: 'market',
    selectedProfiles: [],
    vehicleType: [],
    trailerType: [],
    type: ['NORMAL', 'AUCTION', 'LOT', 'QUOTATION'],
    externalId: null,
    cnpj: null,
    fantasyName: null,
  },
  mine: {
    deliveryStatus: [
      ...Object.keys(onGoingStatus),
    ],
    status: ['IN_DELIVERY'],
    initLaunchDate: null,
    endLaunchDate: null,
    tab: 'my',
    selectedProfiles: [],
    vehicleType: [],
    trailerType: [],
    type: ['NORMAL', 'AUCTION', 'LOT', 'QUOTATION'],
    externalId: null,
    cnpj: null,
    fantasyName: null,
  },
  review: {
    status: ['WAIT_TRANSPORTER_ACCEPT'],
    initLaunchDate: null,
    endLaunchDate: null,
    tab: 'review',
    productProfileIds: [],
    vehicleType: [],
    trailerType: [],
    type: ['NORMAL', 'AUCTION', 'LOT', 'QUOTATION'],
  },
  locked: {
    status: [
      'IN_DELIVERY',
    ],
    deliveryStatus: ['DELIVERED', 'FINISHED'],
    initLaunchDate: null,
    endLaunchDate: null,
    tab: 'locked',
    selectedProfiles: [],
    vehicleType: [],
    trailerType: [],
    type: ['NORMAL', 'AUCTION', 'LOT', 'QUOTATION'],
    externalId: null,
    cnpj: null,
    fantasyName: null,
  },
  closed: {
    status: [
      'FINISHED',
      'CANCELED',
      'EXPIRED',
    ],
    initLaunchDate: null,
    endLaunchDate: null,
    tab: 'closed',
    selectedProfiles: [],
    vehicleType: [],
    trailerType: [],
    type: ['NORMAL', 'AUCTION', 'LOT', 'QUOTATION'],
    externalId: null,
    cnpj: null,
    fantasyName: null,
  },
}
export const trackingStatus = [
  { label: 'Sem rastreador', value: 'NO_TRACKING' },
  { label: 'Aguardando espelhamento', value: 'WAITING_SIGNAL' },
  { label: 'Rastreando', value: 'TRACKING' },
]
export default sectionFiltersMap

